<template>
  <span
    @click="$emit('click', $event)"
    v-bind="$attrs"
    class="app-tag"
    :class="{
      large,
    }"
    :style="{
      backgroundColor,
      color: textColor,
    }"
  >
    <slot />
  </span>
</template>

<script>
import { getTextColor } from '@/helpers'

export default {
  name: 'AppTag',

  emits: ['click'],

  props: {
    large: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    textColor() {
      let textColor = this.$attrs.textColor ?? this.$attrs['text-color']

      if (!textColor) {
        let { backgroundColor } = this

        if (backgroundColor) {
          if (backgroundColor.startsWith('var('))
            backgroundColor = getComputedStyle(document.body).getPropertyValue(
              backgroundColor.slice(4, -1),
            )

          textColor = getTextColor(backgroundColor)
        }
      }

      return textColor
    },

    backgroundColor() {
      let backgroundColor =
        this.$attrs.backgroundColor ??
        this.$attrs.bgColor ??
        this.$attrs['background-color'] ??
        this.$attrs['bg-color']

      if (!backgroundColor) {
        const { primary, secondary, tertiary } = this.$attrs

        if (![undefined, false].includes(primary))
          backgroundColor = 'var(--primary-color)'
        else if (![undefined, false].includes(secondary))
          backgroundColor = 'var(--secondary-color)'
        else if (![undefined, false].includes(tertiary))
          backgroundColor = 'var(--tertiary-color)'
      }

      return backgroundColor
    },
  },
}
</script>

<style lang="scss" scoped>
.app-tag {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0.25em 0.35em;
  border-radius: 5px;
  background-color: rgba(0, 0, 0, 0.15);
  font-size: 0.75rem;
  line-height: 1;

  &.large {
    padding: 0.5em 0.75em;
  }
}
</style>
